import { TermsConditionsPrivacyPolicy } from 'pages/RecommendationV2/Sections/Footer';

const cropwiseLegaldocsURL = 'https://accounts.cropwise.com/app/legaldocs';

export const getUrl = (countryCode: string): TermsConditionsPrivacyPolicy => {
  return {
    termsConditionURL: `${cropwiseLegaldocsURL}/${countryCode}?document_type=terms_and_conditions`,
    privacyPolicy: `${cropwiseLegaldocsURL}/${countryCode}?document_type=privacy_notice`,
    cookiePolicyURL: `${cropwiseLegaldocsURL}/${countryCode}?document_type=cookie_policy`,
  };
};
